import { handleActions } from 'redux-actions';

import {
  revisionHistoryLoading,
  revisionHistoryLoaded,
  revisionHistoryError,
  clearStatementPageRevisionStoreAction,
} from 'store/actions/revision-actions';
import { RevisionList } from 'models/api/revision-list-api-model';

export default handleActions(
  {
    [revisionHistoryLoading]: (revisionList) => {
      return revisionList.setLoading();
    },
    [revisionHistoryError]: (revisionList, { payload }) => {
      return revisionList.setError(payload);
    },
    [revisionHistoryLoaded]: (revisionList, { payload }) => {
      return revisionList.setLoaded(payload);
    },
    [clearStatementPageRevisionStoreAction]: (revisionList, { payload }) => {
      return new RevisionList();
    },
  },
  new RevisionList(),
);
